import styled from 'styled-components';

export const ScrollableList = styled.div`
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #d9d9d9;
  padding: 12px;
  border-radius: 6px;
`;

export const SelectButtonsRow = styled.div`
  margin-top: 8px;
`;

export const InfoTextRow = styled.div`
  margin-top: 12px;
`;

export const CheckboxRow = styled.div`
  margin-bottom: 8px;
`;

export const CommentBox = styled.div``;
